<div class="tick-icon">
  <mat-icon
    [svgIcon]="MatIconEnum.TICK"
  ></mat-icon>
</div>
